import React from "react";
import { VMBuilder } from "../../../commons/base/providers/builder";
import MenuPreparationBomDashboardViewModel from "../view_models/menu_preparation_bom_view_model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

export default class MenuPreparationBomDashboardTableWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<MenuPreparationBomDashboardViewModel>>
                {(vm) => (
                    <div className="overflow-x-auto">
                        <table className="table-fixed w-full text-center border-collapse">
                            <thead>
                                <tr className="bg-gray-300">
                                    <th className="p-2 border border-gray-400 w-1/3">
                                        Material Code
                                    </th>
                                    <th className="p-2 border border-gray-400 w-1/3">
                                        Nama Menu
                                    </th>
                                    <th className="p-2 border border-gray-400 w-1/3">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {vm.getFilteredResultList().map((item) => (
                                    <tr
                                        className="bg-white hover:bg-gray-100 transition"
                                        key={item.id}
                                    >
                                        <td className="p-2 border border-gray-400">
                                            {item.materialCode}
                                        </td>
                                        <td className="p-2 border border-gray-400">
                                            {item.item}
                                        </td>
                                        <td className="p-2 border border-gray-400">
                                            <button
                                                className="px-3 py-1 rounded-md bg-purple-500 hover:bg-purple-700 text-white"
                                                onClick={() => {
                                                    vm.fetchMprDetail(item.id);
                                                    vm.openReadOnlyForm();
                                                }}
                                            >
                                                Lihat Menu Prepare
                                                <FontAwesomeIcon
                                                    className="mx-3"
                                                    icon={faPencil}
                                                />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
